import { Link } from "react-router-dom";
import styled from "styled-components";
import { useSiteSettings } from "../../hooks/useSiteSettings";
import { useTheme } from "../../contexts/ThemeContext";

const LogoContainer = styled.div`
  width: 170px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoImage = styled.img<{ $isDark: boolean }>`
  max-width: 100%;
  height: auto;
  max-height: 60px;
  object-fit: contain;
  ${({ $isDark }) => $isDark && `
    filter: invert(1);
    mix-blend-mode: screen;
  `}
`;

const LogoText = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  color: ${props => props.theme.colors.primary};
  text-decoration: none;
  text-align: center;
  padding: 0.5rem;
  border: 2px solid ${props => props.theme.colors.primary};
  border-radius: 8px;
  background: ${props => props.theme.colors.primary}0d;
  transition: all 0.3s ease;

  &:hover {
    background: ${props => props.theme.colors.primary}1a;
    transform: translateY(-1px);
  }
`;

const LoadingLogo = styled.div`
  width: 150px;
  height: 40px;
  background: linear-gradient(90deg, ${props => props.theme.colors.surface} 25%, ${props => props.theme.colors.border} 50%, ${props => props.theme.colors.surface} 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const BrandLogo = () => {
  const { settings, loading } = useSiteSettings();
  const { isDark } = useTheme();
  
  if (loading) {
    return (
      <LogoContainer>
        <LoadingLogo />
      </LogoContainer>
    );
  }
  
  return (
    <LogoContainer>
      <Link to="/">
        {settings?.logoUrl ? (
          <LogoImage
            src={settings.logoUrl}
            alt={settings.siteName || "Logo"}
            $isDark={isDark}
            onError={(e) => {
              console.error('Logo yüklenemedi:', settings.logoUrl);
              // Hata durumunda text logo\'ya geç
              e.currentTarget.style.display = 'none';
              e.currentTarget.nextElementSibling?.removeAttribute('style');
            }}
          />
        ) : (
          <LogoText>
            {settings?.siteName || "Logo Yükle"}
          </LogoText>
        )}
        
        {/* Fallback text logo (görsel hata verirse gösterilir) */}
        {settings?.logoUrl && (
          <LogoText style={{ display: 'none' }}>
            {settings?.siteName || "Logo"}
          </LogoText>
        )}
      </Link>
    </LogoContainer>
  );
}; 